import React, { useContext, useEffect } from 'react';
import { useSiteContext } from '~/context/SiteContext';

import { TrackerHelpers } from '~/helpers/tracker.helpers';

const TrackingContext = React.createContext();

const TrackingProvider = ({ children }) => {
  const { globals } = useSiteContext();

  const googleAnalyticsUid = globals?.shopInfo?.googleAnalyticsUid;
  const facebookPixelId = globals?.shopInfo?.facebookPixelId;
  const pinterestPixelId = globals?.shopInfo?.pinterestPixelId;
  const tiktokPixelId = globals?.shopInfo?.tikTokPixelId;
  const csGoogleAnalyticsUid = globals?.shopInfo?.csGoogleAnalyticsUid;

  useEffect(() => {
    TrackerHelpers.commentSold.init();
    TrackerHelpers.facebook.init(facebookPixelId);
    TrackerHelpers.googleAnalytics.init(googleAnalyticsUid);
    TrackerHelpers.googleAnalytics.init(csGoogleAnalyticsUid);
    TrackerHelpers.pinterest.init(pinterestPixelId);
    TrackerHelpers.tiktok.init(tiktokPixelId);
  }, [
    facebookPixelId,
    googleAnalyticsUid,
    pinterestPixelId,
    tiktokPixelId,
    csGoogleAnalyticsUid,
  ]);

  const trackPageView = (pathname, search) => {
    const pagePath = pathname + search;
    TrackerHelpers.facebook.trackPageView();
    TrackerHelpers.googleAnalytics.trackPageView(pagePath);
    TrackerHelpers.pinterest.trackPageView();
    TrackerHelpers.tiktok.trackPageView();
  };

  const trackEvent = (name, data, eventData = {}) => {
    TrackerHelpers.commentSold.trackEvent(name, data);
    TrackerHelpers.facebook.trackEvent(name, data, eventData);
    TrackerHelpers.googleAnalytics.trackEvent(name, data);
    TrackerHelpers.pinterest.trackEvent(name, data);
    TrackerHelpers.tiktok.trackEvent(name, data, eventData);
  };

  return (
    <TrackingContext.Provider
      value={{
        trackPageView,
        trackEvent,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};

function useTracking() {
  return useContext(TrackingContext);
}

export { TrackingProvider, useTracking };
